/// <amd-module name="TFS/Token/PatTokenPage/Components/Panels/Panel.Base" />
import { ContentSize } from "VSSUI/Callout";
import { IPanelProps } from "VSSUI/Panel";

export const basePanelProps: Partial<IPanelProps> = {
    size: ContentSize.Medium,
}
